
export function isDateValid(dateString: any) {
  const datePattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  if (!datePattern.test(dateString)) {
    return false;
  }

  const [, day, month, year] = dateString.match(datePattern);

  const dateObject = new Date(`${year}-${month}-${day}`);

  return !isNaN(dateObject.getTime());
}
